import GetOpenAPISpecsSummary_vue_vue_type_script_setup_true_lang_default from "./GetOpenAPISpecsSummary.vue_vue_type_script_setup_true_lang.js";
//#region src/views/Chat/Messages/GetOpenAPISpecsSummary.vue
var GetOpenAPISpecsSummary_default = GetOpenAPISpecsSummary_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { GetOpenAPISpecsSummary_default as default };

//# sourceMappingURL=GetOpenAPISpecsSummary.vue.js.map